import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, useRef, useState, forwardRef } from 'react';
import { useGetEmailDigestPreferencesQuery, useUpdateEmailDigestPreferencesMutation } from 'features/crm';
const EMAIL_DIGEST_PARAM = 'email_digest';
const EMAIL_DIGEST_UNSUBSCRIBE_VALUE = 'unsubscribe';
const shouldUnsubscribeFromMeetingPrepDigest = () => new URLSearchParams(window.location.search).get(EMAIL_DIGEST_PARAM) === EMAIL_DIGEST_UNSUBSCRIBE_VALUE;
const clearEmailDigestParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(EMAIL_DIGEST_PARAM);
  const search = searchParams.toString();
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
};
const containerIsDesktopUpCss = "c12w2sd8";
const containerCss = "c1yq451u";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const sectionContentCss = "scg7ngx";
const SectionContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionContentCss, props.className)} />;
});
const switchContainerCss = "s1cs45o1";
const SwitchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(switchContainerCss, props.className)} />;
});
export const MeetingBriefSettingSection = () => {
  const {
    data,
    isLoading
  } = useGetEmailDigestPreferencesQuery();
  const [updateEmailDigestPreferences] = useUpdateEmailDigestPreferencesMutation();
  const [meetingPrepInDigestEnabled, setMeetingPrepInDigestEnabled] = useState(null);
  const hasHandledEmailDigestUnsubscribe = useRef(false);
  useEffect(() => {
    const enabled = data?.emailDigestPreferences?.meetingPrep?.enabled;
    if (enabled === undefined) return;
    const unsubscribeFromMeetingPrepDigest = async () => {
      try {
        await updateEmailDigestPreferences({
          meetingPrep: {
            enabled: false
          }
        }).unwrap();
        setMeetingPrepInDigestEnabled(false);
      } catch (error) {
        setMeetingPrepInDigestEnabled(enabled);
        console.error('Failed to update setting:', error);
      }
    };
    if (!shouldUnsubscribeFromMeetingPrepDigest() || hasHandledEmailDigestUnsubscribe.current) {
      setMeetingPrepInDigestEnabled(enabled);
      return;
    }
    hasHandledEmailDigestUnsubscribe.current = true;
    clearEmailDigestParam();
    if (!enabled) {
      setMeetingPrepInDigestEnabled(false);
      return;
    }
    unsubscribeFromMeetingPrepDigest();
  }, [data, updateEmailDigestPreferences]);
  const handleChange = async () => {
    if (meetingPrepInDigestEnabled === null) return;
    const newValue = !meetingPrepInDigestEnabled;
    try {
      await updateEmailDigestPreferences({
        meetingPrep: {
          enabled: newValue
        }
      }).unwrap();
      setMeetingPrepInDigestEnabled(newValue);
    } catch (error) {
      console.error('Failed to update setting:', error);
    }
  };
  const checked = !isLoading && meetingPrepInDigestEnabled === true;
  const toggleLabel = I18n.t('publisher.account_settings.meeting_intelligence.communication_settings.meeting_digest_emails_toggle_label');
  return <Container>
      <SectionContent>
        <TitleText size="small">
          {I18n.t('publisher.account_settings.meeting_intelligence.communication_settings.meeting_digest_emails')}
        </TitleText>
        <SwitchContainer>
          <label htmlFor="meeting-brief-emails-enabled">
            <SwitchInput id="meeting-brief-emails-enabled" checked={checked} onChange={() => handleChange()} disabled={isLoading} aria-label={toggleLabel} />
          </label>
          {toggleLabel}
        </SwitchContainer>
      </SectionContent>
    </Container>;
};

require("./meeting_digest_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_digest_section.js");